import React from "react";

function ProductCards(props) {
  const handleCardClick = () => {
    if (props.url) {
      window.open(props.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div 
      className={`product-card ${props.url ? 'clickable' : ''}`}
      onClick={handleCardClick}
      style={props.url ? { cursor: 'pointer' } : {}}
    >
      <div className="product-image-container">
        <img 
          src={props.imgPath} 
          alt={props.title} 
          className="product-image"
        />
      </div>
      <div className="product-info">
        <div className="product-category">{props.category}</div>
        <h3 className="product-title">{props.title}</h3>
        <p className="product-description">
          {props.description}
        </p>
      </div>
    </div>
  );
}

export default ProductCards;
